import React, { FC } from 'react';
import { ContainerProps } from './models';
import classNames from 'classnames';
import './Container.scss';

const Container: FC<ContainerProps> = ({
  children,
  className,
  maxWidth = 'L',
  bgColor,
  isLeft = false,
  fixed = false,
}) => {
  const containerClasses = classNames('container', className, {
    [`container--${maxWidth}`]: maxWidth,
    'container--left-align': isLeft,
  });
  const containerWithBgClasses = classNames('container-fluid', {
    [`container-fluid--${bgColor}`]: bgColor,
    [`container-fluid--fixed`]: fixed,
  });

  return bgColor ? (
    <div className={containerWithBgClasses}>
      <div className={containerClasses}>{children}</div>
    </div>
  ) : (
    <div className={containerClasses}>{children}</div>
  );
};

export default Container;
